import {
  Add_Channal,
  delete_Channal,
  Get_Error,
  get_one_channal,
  GetAll_Channal,
  update_one_channal,
} from '../Types';

const intial = {
  channal: [],
  UpdateChannal: [],
  loading: true,
};

const Channal_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_Channal:
      return {
        ...state,
        channal: action.payload,
        loading: false,
      };
    case GetAll_Channal:
      return {
        ...state,
        channal: action.payload,
        loading: false,
      };
    case delete_Channal:
      return {
        ...state,
        channal: action.payload,
        loading: false,
      };
    case get_one_channal:
      return {
        ...state,
        channal: action.payload,
        loading: false,
      };
    case update_one_channal:
      return {
        ...state,
        UpdateChannal: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        channal: action.payload,
      };
    default:
      return state;
  }
};

export default Channal_Reducer;
